var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-take-page__text"},[_c('h3',{staticClass:"course-take-page__text-title"},[_vm._v(_vm._s(_vm.item.title))]),_c(_setup.RichText,{staticClass:"course-take-page__text-content",attrs:{"content":_vm.item.description || ''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }